// eslint-disable-next-line banned-modules
'use strict';

import './style.less';
import Widget from '@/widgets/base.widget';
import template from './template.ejs';
import validationTemplate from '@/widgets/validationErrorsTemplate.ejs';
// import Inputmask from 'jquery.inputmask/dist/inputmask/inputmask';
import 'jquery.inputmask/dist/inputmask/inputmask.extensions';
import 'jquery.inputmask/dist/inputmask/inputmask.date.extensions';
import Phone from '../../../react/components/Phone/Phone';
import { ReactUtils } from '../../utils/react-utils';

export default Widget.extend({
	validationTemplate,

	template,

	events: {},

	initialize() {
		this.disabled = String(this.options.disabled) === 'true';
		this.deletableField = String(this.options.deletableField) === 'true';

		this.countries = STATE.getCountries().sort((a, b) => {
			return a.caption - b.caption;
		});

		this.render({});
	},

	applyBinding(model) {
		this.model = model;

		this.rootEl = ReactUtils.renderReactApp({
			viewId: this.cid,
			rootHtmlElement: this.$el.find('.r-control').get(0),
			renderAppComponent: Phone,
			renderAppComponentProps: {
				...this.options,
				disabled: this.disabled,
				deletableField: this.deletableField,
				countries: this.countries,
				model: this.model,
			},
		});
	},
});
